import React from 'react';
import { StyleSheet } from 'react-native';

import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

type CountdownTimerProps = {
    seconds: number;
};

export const CountdownTimer = ({ seconds }: CountdownTimerProps) => {
    const countdownSeconds = seconds <= 0 ? 0 : seconds;
    const hours = Math.floor(countdownSeconds / 3600);
    const minutes = Math.floor((countdownSeconds % 3600) / 60);
    const secs = countdownSeconds % 60;

    const units = [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        secs.toString().padStart(2, '0'),
    ];

    return (
        <Row alignItems={'center'}>
            {units.map((unit, index) => (
                <React.Fragment key={index}>
                    <Box
                        backgroundColor={ds.colorToken.background.neutral.subtle}
                        borderRadius="r8"
                        py="s10"
                        alignItems={'center'}
                        style={styles.unitContainer}
                    >
                        <Text color="neutral300" variant={'titleMedium'}>
                            {unit}
                        </Text>
                    </Box>
                    {index < units.length - 1 && (
                        <Text color="neutral300" variant={'titleMedium'} mx="s6">
                            :
                        </Text>
                    )}
                </React.Fragment>
            ))}
        </Row>
    );
};

const styles = StyleSheet.create({
    unitContainer: {
        width: 36,
    },
});
